import React, { useState } from 'react';
import { IonButton, IonCol, IonGrid, IonIcon, IonRow, IonToast } from '@ionic/react';
import { setKey } from '../utilities/Storage';
import { DownloadArrivalsReport } from '../utilities/DownloadArrivalsReport';
import { document } from 'ionicons/icons';
import { userIsSelfEmployed } from '../dataStructures/user/predicates';
import { useAuthentication } from '../authentication/authentication-hook';
import {useUserPermissions} from "../authorisation/authorisation-hook";

export default function Menu({ dismiss }) {
  const { isLoggedIn, logout, login } = useAuthentication();
  const [toast, setToast] = useState();
  const [toastColor, setToastColor] = useState('success');
  const [downloadInProgress, setDownloadInProgress] = useState(false);
  const { permissions } = useUserPermissions();

  return (
    <IonGrid>
        {isLoggedIn && permissions.canViewArrivalsReport && (
            <IonRow>
                <IonCol>
                    <IonButton
                        fill="solid"
                        color="medium"
                        disabled={downloadInProgress}
                        onClick={async () => {
                            try {
                                setDownloadInProgress(true);
                                await DownloadArrivalsReport();
                            } catch (err) {
                                setToastColor('warning');
                                setToast(err.message);
                            } finally {
                                setDownloadInProgress(false);
                            }
                        }}
                    >
                        Arrivals Report
                        <IonIcon icon={document} size='small' />
                    </IonButton>
                </IonCol>
            </IonRow>
        )}

      <IonRow>
        <IonCol>
          <IonButton color="medium" expand="block" onClick={() => {
            setKey('lastCommonUpdate', '1899-01-01 00:00:00');
            setToast('data will refresh in a few moments');
            dismiss();
          }}>
            Refresh
          </IonButton>
        </IonCol>
      </IonRow>

      <IonRow>
        <IonCol>
          <IonButton color="medium" expand="block" href="/help">
            Help
          </IonButton>
        </IonCol>
      </IonRow>

      <IonRow>
        <IonCol>
          {isLoggedIn ? (
            <IonButton color="medium" expand="block" onClick={() => {
              dismiss();
              logout();
            }}>
              Log Out
            </IonButton>
          ) : (
            <IonButton color="medium" expand="block" onClick={() => {
                dismiss();
                login();
            }}>
              Log In
            </IonButton>
          )}
        </IonCol>
      </IonRow>

      <IonToast
        isOpen={toast && toast.length > 0}
        onDidDismiss={() => {setToast(); setToastColor('success');}}
        message={toast}
        duration={2000}
        color={toastColor}
        position="middle"
      />
    </IonGrid>
  );
}
